import PropTypes from 'prop-types';
import { Button, Stack } from '@mui/material';

const styles = {
  container: ({ palette, breakpoints }) => ({
    borderRadius: 5,
    padding: 4,
    backgroundColor: palette.colors.lightPale,
    [breakpoints.up('md')]: {
      paddingBlock: 8,
      paddingInline: 5,
    },
  }),
  button: {
    width: '100%',
    maxWidth: 355,
  },
};

const CreateSection = ({ buttons }) => (
  <Stack
    direction={{ xs: 'column', md: 'row' }}
    spacing={{ xs: 4, md: 10 }}
    justifyContent="center"
    alignItems="center"
    sx={styles.container}
  >
    {buttons.map(({ id, buttonLabel = '', onClick }) => (
      <Button key={id} id={id} onClick={onClick} sx={styles.button}>
        {buttonLabel}
      </Button>
    ))}
  </Stack>
);

CreateSection.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      buttonLabel: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    }),
  ).isRequired,
};

export default CreateSection;
